import events from '../events/events';

const Calendar = {};

/**
 * Calendar plugin
 *
 * @param Vue
 * @param options
 */
Calendar.install = function(Vue, options)
{
    let methods =
    {
        open(event, payload)
        {
            events.$emit('toolbox.open', 'calendar', event, payload);
        },

        close()
        {
            events.$emit('toolbox.close');
        },
    };

    // register global methods
    Vue.calendar = methods;

    // register instance methods
    Vue.prototype.$calendar = methods;
};

export default Calendar;



// WEBPACK FOOTER //
// ./src/js/plugins/calendar.js